function Privacy() {
    return (
      <div style={styles.container}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <div style={styles.content}>
          <p style={styles.lastUpdated}>Last updated: December 20th, 2024</p>
          
          <h2 style={styles.sectionTitle}>Introduction</h2>
          <p>At Day By Data, accessible from daybydata.app, our primary commitment is protecting your privacy and ensuring transparent handling of your personal data. This Privacy Policy outlines how we handle data from Apple Health and Spotify, and how we protect your information.</p>

          <h2 style={styles.sectionTitle}>Data Sources and Collection</h2>
          <p>Day By Data interfaces with two primary data sources:</p>
          <ul style={styles.list}>
            <li>Apple Health Data: Including but not limited to steps, heart rate, distance, and other health metrics</li>
            <li>Spotify Data: Including listening history and music preferences</li>
          </ul>
          <p><strong>Important:</strong> We only access and process this data with your explicit consent. No data is collected or stored without your knowledge or permission.</p>

          <h2 style={styles.sectionTitle}>How We Use Your Data</h2>
          <p>Your data is used exclusively for:</p>
          <ul style={styles.list}>
            <li>Creating personalized visualizations within the app</li>
            <li>Generating insights about your health and music habits</li>
            <li>Improving app functionality and user experience</li>
          </ul>
          <p>We do not store your personal data on our servers. All processing occurs locally on your device.</p>

          <h2 style={styles.sectionTitle}>Data Security</h2>
          <p>We implement strict security measures to protect your data:</p>
          <ul style={styles.list}>
            <li>All data processing occurs locally on your device</li>
            <li>No personal health or music data is transmitted to our servers</li>
            <li>We adhere to Apple's privacy guidelines for HealthKit data</li>
            <li>We follow Spotify's developer terms of service for music data</li>
          </ul>

          <h2 style={styles.sectionTitle}>Your Rights</h2>
          <p>You have complete control over your data:</p>
          <ul style={styles.list}>
            <li>You can revoke access to Apple Health or Spotify data at any time</li>
            <li>You can request deletion of any cached data within the app</li>
            <li>You control which health metrics and music data the app can access</li>
          </ul>

          <h2 style={styles.sectionTitle}>GDPR and CCPA Compliance</h2>
          <p>We respect and comply with both GDPR and CCPA requirements. You have the right to:</p>
          <ul style={styles.list}>
            <li>Access your personal data</li>
            <li>Correct any inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Restrict or object to data processing</li>
            <li>Data portability</li>
          </ul>

          <h2 style={styles.sectionTitle}>Children's Privacy</h2>
          <p>Day By Data does not knowingly collect data from children under 13. If you believe your child has provided personal information through our app, please contact us, and we will promptly remove such information.</p>

          <h2 style={styles.sectionTitle}>Contact Us</h2>
          <p>If you have questions about this Privacy Policy or our data practices, please contact us at:</p>
          <p>Email: <a href="mailto:pete@ngenart.com">pete@ngenart.com</a></p>
        </div>
      </div>
    );
}

const styles = {
    container: {
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: '"Bodoni Moda", serif',
        color: '#0a0a0a',
        backgroundColor: '#fffef7',
    },
    title: {
        fontSize: '2.5rem',
        marginBottom: '2rem',
        textAlign: 'center',
    },
    content: {
        marginTop: '2rem',
    },
    lastUpdated: {
        color: '#666',
        marginBottom: '2rem',
    },
    sectionTitle: {
        fontSize: '1.8rem',
        marginTop: '2.5rem',
        marginBottom: '1rem',
    },
    list: {
        marginLeft: '1.5rem',
        marginBottom: '1.5rem',
    },
};

export default Privacy;